//.......Functional component........
import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Window from "../../../../elements/window";
import Loader from "../../../../../settings/loader";
import Slide1 from "./slides/slide1";
import Slide2 from "./slides/slide2";
import Slide3 from "./slides/slide3";
import { useAppContext } from "../../../../../../AppContext";

const PayTypeSales = (props) => {
  const { filterValue, setFilterValue } = useAppContext();
  const [data, setData] = useState({
    sales: {
      data: [],
      state: false,
    },
    payType: {
      data: [],
      state: false,
    },
    brands: {
      data: [],
      state: false,
    },
    chains: {
      data: [],
      state: false,
    },
    currency: {
      base: {},
      state: false,
    },
    state: false,
  });

  const [load, setLoad] = useState(0);

  const getBrand = useCallback(
    async (headers) => {
      try {
        const response = await axios.get(props.chimeraserv.urlGet + "/brand", {
          headers,
        });
        let brandData = [];
        if (Object.keys(response.data).length) {
          brandData = response.data;
        }
        return brandData;
      } catch (error) {
        return [];
      }
    },
    [props.chimeraserv.urlGet]
  );

  const getChain = useCallback(
    async (headers) => {
      try {
        const response = await axios.get(props.chimeraserv.urlGet + "/chain", {
          headers,
        });
        let chainData = [];
        if (Object.keys(response.data).length) {
          chainData = response.data;
        }
        return chainData;
      } catch (error) {
        return [];
      }
    },
    [props.chimeraserv.urlGet]
  );

  const getCurrency = useCallback(
    async (headers) => {
      try {
        const response = await axios.get(props.chimeraserv.urlGet + "/group", {
          headers,
        });
        let currencyData = [];
        if (Object.keys(response.data).length) {
          currencyData = response.data;
        }
        return currencyData;
      } catch (error) {
        return [];
      }
    },
    [props.chimeraserv.urlGet]
  );

  const getPaytype = useCallback(
    async (headers) => {
      try {
        const response = await axios.get(
          props.chimeraserv.urlGet + "/paytype",
          { headers }
        );

        return response.data;
      } catch (error) {
        return [];
      }
    },
    [props.chimeraserv.urlGet]
  );
  // const getPaytype = useCallback(
  //   async (headers = null) => {
  //     const chaKey = filterValue?.data.chains[0]?.chaKey || null;
  //     try {
  //       // Build URL with optional chaKey parameter
  //       let url = props.chimeraserv.urlGet + "/paytype";
  //       if (chaKey) {
  //         url += "/" + chaKey;
  //       }

  //       const response = await axios.get(url, { headers });
  //       return response.data;
  //     } catch (error) {
  //       console.error("Error fetching paytype data:", error);
  //       return [];
  //     }
  //   },
  //   [props.chimeraserv.urlGet]
  // );
  const getSalesData = useCallback(
    async (headers) => {
      try {
        const response = await axios.post(
          props.chimeraserv.urlGet + "/sales/set/0/",
          { id: props.filter.base64 },
          { headers }
        );
        return response.data;
      } catch (error) {
        return [];
      }
    },
    [props.chimeraserv.urlGet, props.filter.base64]
  );

  const loadAllData = useCallback(async () => {
    if (!props.user.data) return;

    const headers = {
      Authorization: props.user.data.usrKey,
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    try {
      // Load all data in parallel
      const [salesData, paytypeData, chainData, brandData, currencyData] =
        await Promise.all([
          getSalesData(headers),
          getPaytype(headers),
          getChain(headers),
          getBrand(headers),
          getCurrency(headers),
        ]);

      // Process currency data
      const array = [];
      const currency = currencyData
        .map((group) => group.baseCurr)
        .filter((currency) => !array.includes(currency));

      // Update all data at once
      setData({
        sales: {
          data: salesData,
          state: true,
        },
        payType: {
          data: paytypeData,
          state: true,
        },
        chains: {
          data: chainData,
          state: true,
        },
        brands: {
          data: brandData,
          state: true,
        },
        currency: {
          base: currency[0] ? currency[0]?.toUpperCase() : "QAR",
          state: true,
        },
        state: true,
      });

      setLoad(1);
    } catch (error) {
      console.error("Error loading data:", error);
    }
  }, [
    props.user.data,
    getSalesData,
    getPaytype,
    getChain,
    getBrand,
    getCurrency,
  ]);

  // Load data on component mount
  useEffect(() => {
    loadAllData();
  }, [loadAllData]);

  // Debug logging effect
  // useEffect(() => {
  //   // console.log("PayTypeSales component updated, state:", data);
  //   // console.log("Paytype status:", data.payType.state);
  //   // console.log("Sales status:", data.sales.state);
  //   // console.log("Brands status:", data.brands.state);
  //   // console.log("Chains status:", data.chains.state);
  //   // console.log("Currency status:", data.currency.state);
  // }, [data]);

  return (
    <section>
      {!load ? (
        <Loader />
      ) : (
        <div>
          <Window
            user={props.user}
            chimeraserv={props.chimeraserv}
            title={"Sales By Payment Type"}
          >
            <Slide3
              user={props.user}
              chimeraserv={props.chimeraserv}
              filter={props.filter}
              data={data}
            />
          </Window>
          <div className={["contentContainer"]}>
            <div className={["contentRow"]} style={{ width: "49.55%" }}>
              <Window
                user={props.user}
                chimeraserv={props.chimeraserv}
                title={"Payment Types"}
                horizontal
              >
                <Slide1
                  user={props.user}
                  chimeraserv={props.chimeraserv}
                  filter={props.filter}
                  data={data}
                />
              </Window>
            </div>
            <div className={["contentRow"]} style={{ width: "49.55%" }}>
              <Window
                user={props.user}
                chimeraserv={props.chimeraserv}
                title={"Payment Type by percentage"}
                horizontal
              >
                <Slide2
                  user={props.user}
                  chimeraserv={props.chimeraserv}
                  filter={props.filter}
                  data={data}
                />
              </Window>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default PayTypeSales;
